import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';
import API from '../Common/Endpoint/serviceConstrants';

export const getMyAccountPageSectionApi = async (payload) => {
    const { data = {} } = await axiosInstanceClient.get(API.MyAccountSection, {
        params: {
            memberIdentifier: payload.memberIdentifier,
            cardCode: payload.cardCode,
            cardsNetwork: payload.cardsNetwork,
        },
    });
    return data;
};